export default __webpack_public_path__ + "static/pic-2-8369c71d6acf01233684a34be5a88258.png";